import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DropdownService {
    private openDropdownSource = new Subject<string>();

    /**
     * Bir dropdown açıldığında onun ID'sini yayınlar.
     */
    openDropdown$ = this.openDropdownSource.asObservable();

    /**
     * Bir dropdown açıldığında bu metodu çağırır.
     * @param id Açılan dropdown'ın benzersiz ID'si
     */
    notifyOpen(id: string): void {
        this.openDropdownSource.next(id);
    }
}
